import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import {Power1} from 'gsap';

// Register plugins
gsap.registerPlugin(CSSRulePlugin, ScrollTrigger);

export const tl = gsap.timeline();

export const colorchange = () => {
    const btn = document.querySelectorAll('.btn');
    const overlay = document.querySelector('.overlay');
    btn.forEach(e => {
        e.addEventListener('click', () => {
            overlay.style.setProperty('--bg', e.getAttribute('data-color'));
        })
    })
}

export const overlayUp = (e) => {
    return tl.to(e, {
        display: 'block', 
        top: '-6.4rem', 
        duration:.8,
        ease: Power1.easeInOut
    });
}

export const hide = () => {
    gsap.set('.overlay', {
        display: 'none', 
        top: '100vh',
    })
    gsap.set('.theme-content', {
        y: '100vh'
    })
}

export const moveUp = (e, res) => {
    let val;
    res ? val = 900 : val = 0;
    gsap.matchMedia().add(
        `(min-width: ${val}px)`, () => {
            tl.from(e, {
                y: '10rem',
                scrollTrigger: {
                    trigger: e,
                    end: 'top 50%',
                    scrub: true
                }
            })
        },
    )
}